module.exports = __webpack_public_path__ + "files/a6443a9114a92e980b743ede54d7c6c1.svg";